export const PAGE_GENERAL = {
  detail: '{item} détail',
  modification: '{item} modification',
  connexion: 'Connexion',
  home: 'Accueil',
};

export const PAGE_NAME_PATRIMOINE = {
  emplacement: {
    liste: 'Liste emplacements',
    creation: 'Création emplacement',
    modification: 'Modification emplacement',
    remplacementFace: 'Remplacement produit face',
    dispositifPublicitaire: {
      liste: 'Liste dispositifs',
      creation: 'Création dispositif publicitaire',
      modification: 'Modification dispositif publicitaire',
    },
    materiel: {
      liste: 'Liste matériels',
      creation: 'Création matériel',
      modification: 'Matériel modification',
    },
    face: {
      liste: 'Liste faces',
      creation: 'Création face',
      modification: 'Faces modification',
    },
    adresse: {
      creation: 'Création adresse',
    },
    parking: {
      creation: 'Création parking',
    },
    centreCommercial: {
      creation: 'Création centre commercial',
    },
    ligneBus: {
      creation: 'Création ligne bus',
    },
  },
  collectivite: {
    liste: 'Liste collectivités TLPE',
    creation: 'Création collectivité TLPE',
  },
  commandeTlpe: {
    liste: 'Historique déclaration TLPE',
  },
  titreRecette: {
    creation: 'Création titre de recette',
    liste: 'Liste titre de recette',
  },
  paiementRecette: {
    liste: 'Liste des titres de recette à payer',
  },
  lotPaiementRecette: {
    liste: 'Liste des lots de paiement',
  },
  journalPaiementRecette: {
    liste: 'Journal paiements',
  },
};

export const PAGE_NAME_BAUX = {
  contrat: {
    creation: 'Création bail',
    listeBaux: 'Liste baux',
    listeBauxReconductible: 'Liste baux reconductibles',
    listeBauxMateriel: 'Liste baux par matériel',
  },
  bailleur: {
    liste: 'Liste bailleurs',
    creation: 'Création bailleur',
  },
  factureAchatBailleur: {
    creation: 'Création facture bailleur',
    liste: 'Liste factures bailleur',
  },
  factureAchat: {
    liste: 'Liste factures achat',
  },
  constatationCharge: {
    liste: 'Liste constatation charges',
  },
  echeancesAPayer: {
    liste: 'Liste échéances à payer',
  },
  produitAchatLoc: {
    liste: 'Liste produits achat location',
  },
  lotPaiement: {
    liste: 'Liste lots paiements',
  },
  journalPaiements: {
    liste: 'Journal paiements',
  },
  commandeAchat: {
    liste: 'Liste commandes achat bailleur',
  },
};

export const PAGE_NAME_COMPTA = {
  journalEcriture: {
    liste: 'Liste journaux',
    actions: {
      supprimer: 'Supprimer',
    },
  },
  lots: {
    liste: 'Liste lots comptables',
  },
  exerciceComptable: {
    liste: 'Liste exercices comptables',
    creation: 'Création exercice comptable',
  },
  situation: {
    liste: 'Liste situation',
  },
  operationDiverse: {
    liste: 'Opérations diverses',
    creation: 'Création opération diverse',
  },
  ecritureComptable: {
    liste: 'Ecritures comptables',
  },
};

export const PAGE_NAME_STOCK = {
  bonStock: {
    liste: 'Liste des {bons}',
    detail: 'Détails {bon}',
    creationEntree: 'Création de bon d\'entrée',
    creationSortie: 'Création de bon de sortie',
    modifEntree: '{libelle} modification bon d\'entrée',
    modifSortie: '{libelle} modification bon de sortie',
  },
};

export const PAGE_NAME_LOGISTIQUE = {
  chargeTravail: {
    listeAff: 'Gestion charges travail affichage',
    listeTech: 'Gestion charges travail technique',
  },
  ot: {
    listeAff: 'Liste OT affichages',
    listeTech: 'Liste OT techniques',
    remplacementFaceOtAff: 'Modification OT affichage',
    affectationLogistique: 'Affectations Logistiques',
    listeAjoutPatri: 'Ajout patrimoine à OT technique',
    listeAjoutDemande: 'Ajout demande à OT technique',
    creationOtTech: 'Création OT Tecnhique',
    listeImpression: 'Liste OT impressions',
    detailBonExpedition: 'Détail bon d\'expédition',
    editBonExpedition: 'Modifier le bon d\'expédition',
    listBonExpedition: 'Liste des bons d\'expédition',
  },
  demande: {
    listeDemandeAff: 'Liste demandes affichages',
    listeDemandeManuel: 'Liste demandes manuelles',
    gestionAffectation: 'Gestion affectations',
    listeAffectation: 'Liste des affectations logistiques affichage',
    restriction: 'Liste restrictions',
    facesDispo: 'Liste faces disponibles',
    listeAjoutPatri: 'Ajout patrimoine à demande',
  },
  tourneeModele: {
    creation: 'Création liste d’affichage',
    liste: 'Listes d’affichage',
    ajoutFace: 'Ajouter face liste d’affichage',
  },
  intervention: {
    creation: 'Création demande intervention',
    liste: 'Liste demandes intervention',
  },
  typeOt: {
    liste: 'Liste types OT technique',
    creation: 'Création type OT technique',
  },
  projet: {
    liste: 'Liste projets',
    edition: 'Modification projet',
  },
  previsionelDepart: {
    liste: 'Prévisionnel de départ',
  },
  audit: {
    liste: 'Liste audits techniques',
    creation: 'Création audit technique',
  },
  expedition: {
    liste: 'Liste des expéditions',
  },
  suiviProduction: {
    liste: 'Suivi de Production',
  },
};

export const PAGE_NAME_GESCOM = {
  devis: {
    liste: 'Liste devis',
    creation: 'Création devis',
  },
  commande: {
    listeCommande: 'Liste commandes',
    listeCommandeBAF: 'Liste commandes à facturer',
    listeCommandeAFacturer: 'Liste échéances à facturer',
    listeCommandesAFacturer: 'Liste commandes à facturer',
    listeCommandeARenouveler: 'Liste commandes à renouveler',
    creation: 'Création commande',
  },
  facture: {
    liste: 'Liste factures',
    creation: 'Création facture',
  },
  lignesFacture: {
    liste: 'Liste lignes facture',
  },
  lignesCommandes: {
    listeLigneCmd: 'Liste lignes commande',
    listeARenouveler: 'Liste lignes de commande à renouveler',
  },
  lignesDevis: {
    listeLigneDvs: 'Liste lignes devis',
  },
  client: {
    liste: 'Liste clients',
    creation: 'Création client',
    encoursClient: {
      modification: 'Encours client modification',
    },
  },
  contact: {
    liste: 'Liste contacts',
    creation: 'Création contact',
  },
  produit: {
    listeProduit: 'Liste produits',
    listeProduitNonCom: 'Liste produits non commercialisables',
    creation: 'Création produit',
    creationFace: 'Création produit face LC',
    creationSalon: 'Création produit salon',
    creationAutre: 'Création produit autre',
    creationSponsoring: 'Création produit sponsoring / événementiel',
    creationPresse: 'Création produit presse',
    creationReseau: 'Création produit réseau tempo',
    creationReseauLc: 'Création produit réseau LC',
    creationReseauMairie: 'Création produit réseau mairie',
    creationEcranNumerique: 'Création produit écran numérique',
    creationReseauNumerique: 'Création produit réseau numérique',
    creationProduitLocation: 'Création produit location papier',
    creationProduitLocationNumerique: 'Création produit location numérique',
    creationProduitDivers: 'Création produit divers',
    creationProduitDispositif: 'Création produit dispositif',
    ajoutProduitAssocie: 'Ajout produit associé',
    listeProduitPresse: 'Liste produits presse',
  },
  regroupementProduit: {
    liste: 'Regroupements de produit',
    creation: 'Création d\'un regroupement de produit',
  },
  produitReseauTempo: {
    liste: 'Liste produits réseau temporaire',
  },
  produitReseauLc: {
    liste: 'Liste produits réseau Lc',
  },
  produitReseauMairie: {
    liste: 'Liste produits réseau mairie',
  },
  produitReseauTempoDispo: {
    liste: 'Liste réseaux tempo dispo',
  },
  produitFace: {
    liste: 'Liste produits face',
    listeSuiviAffectations: 'Suivi d\'affectations',
  },
  produitEcranNumerique: {
    liste: 'Liste produits écran numérique',
  },
  produitReseauNumerique: {
    liste: 'Liste produits réseau numérique',
  },
  remiseBancaire: {
    liste: 'Liste remises bancaires',
    creationReglement: 'Création règlement',
    modififcationReglement: 'Règlement modification',
  },
  journalReglements: {
    liste: 'Journal règlements',
  },
  planning: {
    face: 'Planning face unitaire',
    reseauTempo: 'Planning réseau tempo',
    reseauNumerique: 'Planning réseau numérique',
    ecranNumerique: 'Planning écran numérique',
    reseauLc: 'Planning réseau LC',
    reseauMairie: 'Planning réseau mairie',
    salon: 'Planning salon',
    sponsoring: 'Planning sponsoring / événementiel',
    autre: 'Planning autre',
    presse: 'Planning presse',
  },
  retard: {
    listeRelance: 'Liste relances',
    liste: 'Liste retards paiement',
    listeRelanceSave: 'Liste relances enregistrées',
    creation: 'Création relance',
    creationRelanceGroupe: 'Création relance',
  },
  relanceOption: {
    liste: 'Liste relances d\'option',
  },
  demande: {
    liste: 'Gestion des demandes',
  },
  echeancePaiement: {
    liste: 'Liste des échéances à payer',
  },
  retrocession: {
    liste: 'Liste des rétrocessions',
  },
  factor: {
    liste: 'Liste des factors',
  },
  transmission: {
    liste: 'Liste des transmissions',
  },
  outils: {
    cartographie: 'Cartographie',
  },
  campagne: {
    liste: 'Liste des campagnes',
    creation: 'Création Campagne',
  },
  importIdelia: {
    import: 'Import de données',
  },
};

export const PAGE_NAME_PARAMETRAGE = {
  parametrage: {
    liste: 'Liste paramétrages',
  },
  role: {
    liste: 'Liste rôles',
    creation: 'Création rôle',
  },
  periodicite: {
    liste: 'Liste périodicité',
  },
  parametrageEdition: {
    liste: 'Liste paramètres éditions',
  },
  collaborateurs: {
    liste: 'Liste collaborateurs',
    creation: 'Création collaborateur',
  },
  societes: {
    liste: 'Liste sociétés',
  },
  agence: {
    creation: 'Création agence',
    editionBat: 'Modifier édition BAT',
    mailBat: 'Modifier mail BAT',
  },
  contratNature: {
    liste: 'Liste natures bail',
  },
  signataire: {
    liste: 'Liste signataires',
  },
  typeProduit: {
    liste: 'Liste types produit',
  },
  couleurEncart: {
    liste: 'Liste couleurs encarts',
  },
  regleFacturation: {
    liste: 'Liste règles facturation',
    detail: 'Détail règle facturation',
    edit: 'Edition règle facturation',
  },
  emplacementPresse: {
    liste: 'Liste emplacements presse',
  },
  surface: {
    liste: 'Liste des surfaces',
  },
  typeFormatPresse: {
    liste: 'Liste des types de format presse',
    creation: 'Création d\'un type de format presse',
  },
  modeDistribution: {
    liste: 'Liste des modes de distribution',
  },
  typeEvenementSponsoring: {
    liste: 'Liste des types d\'événements sponsoring',
  },
  modeReglement: {
    liste: 'Liste modes règlement',
  },
  domiciliationBancaire: {
    liste: 'Liste domiciliations bancaires',
    creation: 'Création domiciliation bancaire',
  },
  natureProduit: {
    liste: 'Liste natures produit',
  },
  schemaComptable: {
    liste: 'Liste schémas comptables',
    creation: 'Création schéma comptable',
  },
  commentaires: {
    liste: 'Liste commentaires',
  },
  libellesRemises: {
    liste: 'Liste remises',
  },
  produitsAchat: {
    liste: 'Liste produits achat',
    creationProduitImpressionAffiche: 'Création produit impression d\'affiche',
  },
  civilite: {
    liste: 'Liste civilités',
  },
  motifBlocage: {
    liste: 'Liste motifs blocage paiement',
  },
  secteurActivite: {
    liste: 'Liste secteurs d\'activités',
  },
  format: {
    liste: 'Liste formats',
  },
  typeReseau: {
    liste: 'Liste types réseau',
  },
  dispositifType: {
    liste: 'Liste types dispositif',
  },
  dispositifSupport: {
    liste: 'Liste supports dispositif',
  },
  localisationMateriel: {
    liste: 'Liste localisations matériel',
  },
  angleVisionMateriel: {
    liste: 'Liste angles vision matériel',
  },
  formatMateriel: {
    liste: 'Liste formats matériel',
  },
  typeMateriel: {
    liste: 'Liste types matériel',
  },
  categorieTlpe: {
    liste: 'Liste catégories TLPE',
  },
  motifFaceNonCom: {
    liste: 'Liste motifs face non commercialisable',
  },
  typePointVente: {
    liste: 'Liste types point de vente',
  },
  profilTiers: {
    liste: 'Liste profils de tiers',
  },
  delaiReglement: {
    liste: 'Liste délais règlement',
  },
  typeTaxationTlpe: {
    liste: 'Liste types taxation tlpe',
    creation: 'Création type taxation tlpe',
  },
  regimeTva: {
    liste: 'Liste régimes TVA',
  },
  compteAnalytique: {
    liste: 'Liste comptes analytiques',
  },
  categorieGroupeProduitDeductible: {
    liste: 'Liste catégories groupes produits déductibles',
  },
  indexation: {
    liste: 'Gestion inflation',
  },
  accessoire: {
    liste: 'Liste accessoires',
  },
  typeContact: {
    liste: 'Liste types de contact',
  },
  typeEvenement: {
    liste: 'Liste des événements',
  },
  motifAnnulationReglement: {
    liste: 'Liste des motifs d\'annulation de règlement',
  },
  etatSuiviAdministratif: {
    liste: 'Etat suivi administratif',
  },
  signatureElectronique: {
    modifierToken: 'Modifier token',
  },
  indiceEtValeur: {
    liste: 'Indice et valeur',
    creation: 'Création Indice et valeur',
  },
  marque: {
    liste: 'Liste marques',
  },
  tag: {
    liste: 'Liste des tags',
  },
  nomenclatureType: {
    liste: 'Liste des nomenclatures',
    creation: 'Création Nomenclature',
  },
  pays: {
    liste: 'Liste des pays',
  },
  fonctionContact: {
    liste: 'Liste des fonctions de contact',
  },
  natureSupportAffiche: {
    liste: 'Liste des natures de support d\'affiche',
  },
  competenceFournisseur: {
    liste: 'Liste des compétences fournisseur',
  },
  formatAffiche: {
    liste: 'Liste formats d\'affiches',
    creation: 'Création format d\'affiche',
  },
  service: {
    liste: 'Liste des services',
    creation: 'Création d\'un service',
  },
};

export const PAGE_MULTI_MODULE = {
  fournisseur: {
    creation: 'Création fournisseur',
  },
  confrere: {
    liste: 'Liste confrères',
  },
  afficheur: {
    liste: 'Liste afficheurs',
  },
  technicien: {
    liste: 'Liste techniciens',
  },
  fournisseurMateriel: {
    liste: 'Liste fournisseurs matériel',
  },
  demarcheur: {
    liste: 'Liste démarcheurs',
  },
  signatureElectronique: {
    liste: 'Liste signatures électroniques',
  },
};

export const PAGE_CONFIG_INTERNE = {
  paramInterneAdmin: {
    liste: 'Paramètrage interne',
  },
  configClient: {
    liste: 'Configuration site',
  },
  importDonnee: 'Import données',
  exportDonnee: 'Export données',
};

export const PAGE_NAME_ACHAT = {
  lieuDeLivraison: {
    liste: 'Liste lieu de livraison',
    creation: 'Création Liste lieu de livraison',
  },
  fournisseurs: {
    liste: 'Liste des fournisseurs',
    creation: 'Création fournisseur',
  },
  commandes: {
    liste: 'Liste des commandes',
    creation: 'Création commande',
  },
  bonReception: {
    liste: 'Liste des bons de réception',
    creation: 'Création bon de réception',
  },
  ligneCommandeAchat: {
    liste: 'Liste lignes commande',
  },
  factures: {
    liste: 'Liste des factures achat',
    creation: 'Création facture achat',
  },
  paiements: {
    liste: 'Liste des factures achat à payer',
  },
  lotDePaiement: {
    liste: 'Liste des lots de paiement factures achat',
  },
  journalPaiements: {
    liste: 'Journal paiements factures achat',
  },
  suiviAchats: {
    liste: 'Liste suivi des achats',
  },
};

export const PAGE_NAME_PRESSE = {
  fournisseurSupport: {
    liste: 'Liste fournisseurs support',
    creation: 'Création fournisseur support',
  },
  parution: {
    liste: 'Liste des parutions',
    creation: 'Création parution',
  },
  planMedia: {
    liste: 'Liste plans médias',
    creation: 'Création plan média',
  },
  marche: {
    liste: 'Liste marchés',
    creation: 'Création marché',
  },
  bat: {
    modification: '{code} suivi BAT',
  },
  moisComptable: {
    liste: 'Liste mois comptables',
    creation: 'Création mois comptable',
  },
  editionMasse: {
    page: 'Edition des produits',
  },
  cheminFer: {
    modification: 'Chemin de fer parution n°{code}',
  },
};

export const PAGE_DEMANDE_IPRESSION = {
  liste: 'Liste demande impression',
  creation: 'Creation demande impression',
  modification: 'Modification demande impression',
  detail: 'Détails demande impression',
};
